import React from "react";
import {
  SimpleForm,
  Create,
  ArrayInput,
  SimpleFormIterator,
  DateTimeInput,
  TextInput,
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ChipField
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TodayIcon from "@material-ui/icons/Today";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import InboxIcon from "@material-ui/icons/Inbox";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";
import { styles } from "../../layout/Styles";
import { listUnidad, turnos } from '../../utils';


export const PesajeMaterialCreateComponent  = (props) => {
  return (
    <Create title="Crear pesaje" {...props}>
      <SimpleForm redirect="/pesaje-material">
          <Grid container spacing={0}>
            <Grid item xs={12} md={3}>
              <Paper style={styles.paperIcon}>
                <AccessTimeIcon style={styles.iconLeft} />
                <SelectInput label="Turno" source="turno" choices={ turnos } fullWidth />
              </Paper>
              <Paper style={styles.paperIcon}>
                <TodayIcon style={styles.iconLeft} />
                <div>
                  <DateTimeInput label="Inicio" source="inicio" fullWidth defaultValue={new Date()} /><br />
                  <DateTimeInput label="Fin" source="fin" fullWidth defaultValue={new Date()} />
                </div>
              </Paper>
              <Paper style={styles.paperIcon}>
                <InboxIcon style={styles.iconLeft} />
                <div>
                  <TextInput label="Fardo Inicial" source="fardoInicial" fullWidth /><br />
                  <TextInput label="Fardo Final" source="fardoFinal" fullWidth />
                </div>
              </Paper>
              <Paper style={styles.paperIcon}>
                <PersonPinCircleIcon style={styles.iconLeft} />
                <ReferenceArrayInput label="Etapas" reference="etapas" source="etapas" perPage={100} sort={{ field: 'nombre', order: 'ASC' }}>
                   <SelectArrayInput optionText="nombre" optionValue="nombre" allowEmpty fullWidth>
                       <ChipField source="nombre" />
                   </SelectArrayInput>
                </ReferenceArrayInput>
              </Paper>
            </Grid>
            <Grid item xs={12} md={9}>
              <Paper style={styles.paper} className="materiales">
                    <ArrayInput source="materiales">
                        <SimpleFormIterator>
                          <ReferenceInput reference="materiales" source="material">
                            <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
                          </ReferenceInput>
                          <TextInput label="Cantidad" source="cantidad" fullWidth />
                          <SelectInput source="unidad" optionValue="unidad" choices={listUnidad} fullWidth />
                        </SimpleFormIterator>
                    </ArrayInput>
              </Paper>
            </Grid>
          </Grid>
      </SimpleForm>
    </Create>
  );
}



// WEBPACK FOOTER //
// ./src/components/PesajeMaterial/PesajeMaterialCreateComponent.js